import $ from 'jquery';


// import slickStyles from 'slick-carousel/slick/slick.css';
// import slick from 'slick-carousel';

const domElements = {};

function projectText() {

  if (storeDomElements() === false) {
    return;
  }

  domElements.texts.each((index, element) => {
    const $text = $(element);
    const $inside = $text.find('.project-text__inside');

    $inside.on('mousewheel', event => {
      console.log('mousewheel', event);
      event.stopPropagation();
    });

  });
}

function storeDomElements() {
  domElements.texts = $('.project-text');
  if (domElements.texts.length < 1) return false;
  return true;
}

export default projectText;